var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "navbar", class: [_vm.bemFacets] },
    [
      _c("navbar-content", {
        attrs: { items: _vm.items, "brand-logo-alt": _vm.brandLogoAlt }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a38f704", { render: render, staticRenderFns: staticRenderFns })
  }
}